const SIGN = {
  POSITIVE: '+',
  NEGATIVE: '-'
}

const NUMBER = {
  MINUS_ONE: -1,
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  SIX: 6,
  ONE_HUNDRED: 100,
  ONE_THOUSAND: 1000
  // here we can manage some constant numbers
}

const STRING = {
  EMPTY_STRING: '',
  COLON: ':'
}

const TIME = {
  MILLISECONDS_IN_A_DAY: 86400000,
  MILLISECONDS_IN_AN_HOUR: 3600000,
  MILLISECONDS_IN_AN_MINUTE: 60000,
  SECONDS_IN_A_MINUTE: 60,
  MINUTES_IN_AN_HOUR: 60,
  HOURS_IN_A_DAY: 24
}

const OPERATOR = {
  OR: 'OR'
}

export {
  NUMBER,
  OPERATOR,
  SIGN,
  STRING,
  TIME
}
